import { render, staticRenderFns } from "./allCallLog.vue?vue&type=template&id=b2e3aff6&scoped=true&"
import script from "./allCallLog.vue?vue&type=script&lang=js&"
export * from "./allCallLog.vue?vue&type=script&lang=js&"
import style0 from "./allCallLog.vue?vue&type=style&index=0&id=b2e3aff6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e3aff6",
  null
  
)

export default component.exports